/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_NoInputs */

const en_directory_knowledge_no = /** @type {(inputs: Directory_Knowledge_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_directory_knowledge_no = /** @type {(inputs: Directory_Knowledge_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`否`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Directory_Knowledge_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_no = /** @type {((inputs?: Directory_Knowledge_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_no(inputs)
	return zh_directory_knowledge_no(inputs)
});
export { directory_knowledge_no as "directory.knowledge.no" }